import { Stepper as MuiStepper, styled } from "@mui/material";

export const Stepper = styled(MuiStepper)(({ theme, orientation }) => {
  const commonSyles = {
    "& .MuiStepLabel-root .Mui-completed": {
      color: theme.palette.primary.main,
      fontWeight: 400,
    },
    "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
      borderStyle: "solid",
    },
    "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
      borderStyle: "solid",
    },
    "& .MuiStepLabel-root .Mui-active": {
      color: theme.palette.primary.main,
      fontWeight: 400,
    },
  };

  // Vertical view
  if (orientation === 'vertical') {
    return {
      ...commonSyles,
      ".MuiStepLabel-alternativeLabel": {
        flexDirection: "row !important",
      },
      ".MuiStepLabel-labelContainer": {
        paddingLeft: 8,
      },
      ".MuiStepLabel-labelContainer span": {
        fontSize: 14,
        lineHeight: 5,
        display: "inline",
      },
      "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
        color: theme.palette.primary.main,
        fontWeight: 400,
      },
      "& .MuiStepConnector-vertical": {
        marginLeft: 19,
        top: -27,
        left: "inherit !important",
        right: "inherit !important",
      },
      "& .MuiStepConnector-line": {
        borderStyle: "dashed",
        borderWidth: ".1em",
        borderColor: theme.palette.primary.main,
        marginTop: theme.spacing(1),
        minHeight: 40,
      },
    }
  }

  // Horizontal view
  return {
    ...commonSyles,
    "& .MuiStep-root": {
      paddingLeft: 0,
      paddingRight: 0,
    },
    ".MuiStepLabel-labelContainer": {
      position: "relative",
    },
    ".MuiStepLabel-labelContainer span": {
      textAlign: "center",
      top: 14,
      left: "50%",
      transform: "translate(-50%, -50%)",
      position: "absolute",
      minWidth: 85,
      fontSize: 14,
      lineHeight: 1,
      display: "block",
    },
    ".MuiStepLabel-label": {
      color: theme.palette.primary.main,
    },
    ".MuiStepLabel-root": {
      flexDirection: 'column',
    },
    ".MuiStepLabel-root .MuiStepLabel-iconContainer": {
      paddingRight: 0,
    },
    "& .MuiStepConnector-line": {
      borderStyle: "dashed",
      borderWidth: "0.1em",
      borderColor: theme.palette.primary.main,
      minWidth: 40,
    },
  }
});
